module.exports = __webpack_public_path__ + "media/images/dobirky-e9e9bcd48a0347a04a8ed15fb43b76f3.png";